<div class="page-title">
  <div class="name"> {{ title | slice:0:25}} <small>{{title?.length > 25 ? '...' : ''}}</small></div>
  <p class="updated"> {{ subtitle }}</p>
</div>
<ng-content></ng-content>
